import Api from '@/plugins/api';

export default {
  all(context, options) {
    const store = context;
    store.state.all.loading = true;
    const promise = Api(store).post('admin/api/user/all', options);
    promise.then((response) => {
      store.state.all.items = response.data;
    });
    promise.finally(() => {
      store.state.all.loading = false;
    });

    return promise;
  },
};
